import { render, staticRenderFns } from "./CommitDemandConfirm.vue?vue&type=template&id=227d02c4&scoped=true"
import script from "./CommitDemandConfirm.vue?vue&type=script&lang=js"
export * from "./CommitDemandConfirm.vue?vue&type=script&lang=js"
import style0 from "./CommitDemandConfirm.vue?vue&type=style&index=0&id=227d02c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227d02c4",
  null
  
)

export default component.exports